/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React from 'react';

export default function TrainingModule({
  theme, selectedDay, setSelectedDay, restDays, currentWorldObj,
  setSelectedWorldModal, stepInputVal, setStepInputVal,
  currentStepsCount, handleSaveStepsForDay, isDark,
  setShowPlanner, workoutPlan, getDaySessionName,
  isTrainingDay, getDayExercises, toggleRestDay, logs,
  isSearchingAlternatives, exerciseToReplace, logInputs,
  handleLogInputChange, handleLogSet, handleRemoveSet,
  fetchExerciseInfo, handleOpenReplaceAlternatives
}) {
  const isRestDay = restDays[selectedDay];
  const currentExercises = getDayExercises(selectedDay);

  return (
    <div className="space-y-8 animate-fadeIn">
      {/* TIMELINE HORIZONTAL */}
      <div className="space-y-4">
        <div className={`flex justify-between items-center text-[10px] ${theme.muted} font-bold uppercase tracking-widest`}>
          <span>Línea del tiempo</span>
          <button onClick={() => setSelectedWorldModal(currentWorldObj)} className={`${theme.text} flex items-center gap-1 hover:opacity-70 transition-opacity`}>
            Fase {currentWorldObj?.id || 1} <span>→</span>
          </button>
        </div>
        <div className="w-full overflow-hidden">
          <div className="flex overflow-x-auto gap-3 pb-4 snap-x scrollbar-none px-1" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
            {Array.from({ length: 60 }, (_, i) => i + 1).map((dayNum) => {
              const isRest = restDays[dayNum];
              const isSelected = selectedDay === dayNum;
              return (
                <button
                  key={dayNum}
                  onClick={() => setSelectedDay(dayNum)}
                  className={`flex-shrink-0 snap-center w-16 h-20 rounded-[1.5rem] flex flex-col items-center justify-center transition-all border ${
                    isSelected ? `${theme.primary} border-transparent scale-105 shadow-lg` : isRest ? `${theme.secondary} ${theme.border} opacity-80` : `${theme.card} ${theme.border} ${theme.muted} hover:opacity-80`
                  }`}
                >
                  <span className="text-[9px] font-bold uppercase tracking-widest opacity-60 mb-1">Día</span>
                  <span className="text-xl font-black">{dayNum}</span>
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {/* PANEL NEAT - PASOS DIARIOS */}
      <div className={`${theme.card} border ${theme.border} rounded-[2rem] p-6 space-y-4 ${theme.shadow}`}>
        <div className="flex justify-between items-center">
          <div>
            <span className={`text-[10px] ${theme.muted} font-bold uppercase tracking-widest block`}>Actividad Diaria (NEAT)</span>
            <h3 className="text-lg font-black">Registro de Pasos</h3>
          </div>
          <span className="text-xs font-extrabold px-3 py-1 bg-emerald-500/10 text-emerald-500 border border-emerald-500/30 rounded-full">
            Meta: 10,000
          </span>
        </div>
        <div className="flex items-center gap-3">
          <div className="flex-1 flex items-center gap-2 border-b border-gray-400/20 pb-1">
            <input 
              type="number" 
              value={stepInputVal !== '' ? stepInputVal : (currentStepsCount || '')} 
              onChange={(e) => setStepInputVal(e.target.value)}
              placeholder="Ej. 8500" 
              className={`w-full bg-transparent py-1 text-2xl font-black outline-none ${theme.text}`}
            />
            <span className={`text-xs ${theme.muted} font-bold uppercase`}>Pasos</span>
          </div>
          <button onClick={handleSaveStepsForDay} className={`px-5 py-3 ${theme.primary} font-black text-[10px] uppercase tracking-widest rounded-full hover:scale-105 transition-transform`}>
            Guardar
          </button>
        </div>
        <div className={`h-2.5 w-full ${isDark ? 'bg-gray-800' : 'bg-gray-200'} rounded-full overflow-hidden`}>
          <div className="h-full bg-emerald-500 transition-all duration-500" style={{ width: `${Math.min(100, (currentStepsCount / 10000) * 100)}%` }}></div>
        </div>
      </div>

      <button onClick={() => setShowPlanner(true)} className={`w-full py-4 rounded-full text-xs font-black uppercase tracking-widest border ${theme.border} ${theme.secondary} ${theme.text} transition-all hover:bg-emerald-500 hover:text-black`}>
        {workoutPlan?.days?.length > 0 ? 'Cambiar plan de entrenamiento' : 'Planificar entrenamiento'}
      </button>

      <div className={`${theme.card} border ${theme.border} rounded-[2rem] p-6 flex justify-between items-center ${theme.shadow} transition-colors duration-500`}>
        <div>
          <span className={`text-[10px] ${theme.muted} font-bold uppercase tracking-widest block mb-2`}>Enfoque de hoy</span>
          <h2 className="text-2xl font-black capitalize">{getDaySessionName(selectedDay)}</h2>
        </div>
        {isTrainingDay(selectedDay) && (
          <span className={`text-xs ${theme.secondary} px-3 py-1 rounded-full border ${theme.border}`}>
            {currentExercises.length} ejercicios
          </span>
        )}
        <button onClick={() => toggleRestDay(selectedDay)} className={`px-5 py-2.5 rounded-full text-[10px] font-bold uppercase tracking-widest transition-all ${isRestDay ? theme.secondary : theme.primary}`}>
          {isRestDay ? 'Entrenar' : 'Descanso'}
        </button>
      </div>

      {/* RENDERIZADO DE EJERCICIOS DEL DÍA */}
      {isRestDay ? (
        <div className={`${theme.card} border ${theme.border} rounded-[2rem] p-10 text-center space-y-4 ${theme.shadow}`}>
          <h3 className="text-xl font-black uppercase tracking-wider">Recuperación Activa</h3>
          <p className={`text-sm ${theme.muted} font-light leading-relaxed`}>La recomposición corporal ocurre en la fase de descanso. Hidrátate y mantén la actividad ligera (NEAT).</p>
        </div>
      ) : currentExercises.length > 0 ? (
        currentExercises.map((ex, idxEx) => {
          const exKey = ex.instanceId || `inst_${selectedDay}_${idxEx}_${ex.id}`;
          const logsToday = logs[`day_${selectedDay}_${exKey}`] || logs[`day_${selectedDay}_${ex.id}`] || [];
          const isReplacing = isSearchingAlternatives && (exerciseToReplace?.instanceId === exKey || exerciseToReplace?.id === ex.id);
          const mediaUrl = ex.video_url || ex.image_url || ex.img;
          const isVideo = mediaUrl && (mediaUrl.endsWith('.mp4') || mediaUrl.endsWith('.webm') || mediaUrl.includes('infografias'));
          const thumbnailUrl = ex.thumbnail_url || (!isVideo ? mediaUrl : undefined);
          const fallbackImg = "https://images.unsplash.com/photo-1517838277536-f5f99be501cd?w=600&q=80";

          return (
            <div key={exKey} className={`${theme.card} border ${theme.border} rounded-[2rem] overflow-hidden space-y-5 pb-6 transition-colors duration-500 ${theme.shadow}`}>
              <div className="relative h-56 w-full group overflow-hidden bg-black">
                {isVideo ? (
                  <video 
                    src={mediaUrl} 
                    autoPlay 
                    loop 
                    muted 
                    playsInline 
                    poster={thumbnailUrl}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <img src={mediaUrl || fallbackImg} alt={ex.name} className="w-full h-full object-cover grayscale opacity-80 group-hover:grayscale-0 transition-all duration-700" />
                )}
                <div className={`absolute inset-0 bg-gradient-to-t ${isDark ? 'from-[#111]' : 'from-white'} via-transparent to-transparent p-6 flex flex-col justify-end pointer-events-none`}>
                  <span className={`self-start text-[9px] ${theme.primary} px-3 py-1.5 rounded-full font-bold uppercase tracking-widest mb-3 pointer-events-auto`}>{ex.target}</span>
                  <h3 className="text-2xl font-black leading-tight pointer-events-auto">{ex.name}</h3>
                </div>
              </div>

              <div className="px-6 space-y-6">
                <div className={`flex justify-between items-center border-b ${theme.border} pb-4`}>
                  <div className="space-y-1">
                    <span className={`text-[10px] ${theme.muted} font-bold uppercase tracking-widest block`}>Volumen</span>
                    <span className="text-sm font-bold">{ex.sets || '3-4'}</span>
                  </div>
                  <div className="space-y-1 text-right">
                    <span className={`text-[10px] ${theme.muted} font-bold uppercase tracking-widest block`}>Reps</span>
                    <span className="text-sm font-bold">{ex.reps || '8-12'}</span>
                  </div>
                </div>

                {logsToday.length > 0 && (
                  <div className="space-y-3">
                    <span className={`text-[10px] ${theme.muted} font-bold uppercase tracking-widest block`}>Log Diario</span>
                    <div className="grid grid-cols-2 gap-3">
                      {logsToday.map((log, idx) => (
                        <div key={idx} className={`${theme.secondary} px-4 py-3 rounded-2xl text-xs flex justify-between items-center font-medium group border ${theme.border}`}>
                          <div>
                            <span className={theme.muted}>Set {idx + 1}</span>
                            <span className="ml-2"><strong className="font-bold">{log.weight}kg</strong> × {log.reps}</span>
                          </div>
                          <button onClick={() => handleRemoveSet(exKey, idx)} className="text-red-500 opacity-0 group-hover:opacity-100 transition-opacity p-1" title="Borrar Set">✕</button>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                <div className="flex gap-2">
                  <input type="number" placeholder="Kg" value={logInputs[exKey]?.weight !== undefined ? logInputs[exKey]?.weight : ''} onChange={(e) => handleLogInputChange(exKey, 'weight', e.target.value)} className={`w-20 bg-transparent border ${theme.border} rounded-2xl text-center text-sm font-bold outline-none ${theme.text} focus:border-emerald-500`} />
                  <input type="number" placeholder="Reps" value={logInputs[exKey]?.reps !== undefined ? logInputs[exKey]?.reps : ''} onChange={(e) => handleLogInputChange(exKey, 'reps', e.target.value)} className={`w-20 bg-transparent border ${theme.border} rounded-2xl text-center text-sm font-bold outline-none ${theme.text} focus:border-emerald-500`} />
                  <button onClick={() => handleLogSet(exKey)} className={`flex-1 py-4 ${theme.primary} font-black rounded-full text-[10px] uppercase tracking-widest shadow-md hover:scale-105 transition-transform`}>Guardar Set</button>
                </div>

                <div className="flex gap-2 pt-2">
                  <button onClick={() => fetchExerciseInfo(ex)} className={`px-4 py-4 ${theme.secondary} border ${theme.border} rounded-full text-xs font-bold uppercase tracking-widest hover:scale-105 transition-transform flex items-center justify-center`} title="Guía Biomecánica">ℹ️</button>
                  <button onClick={() => handleOpenReplaceAlternatives(ex, idxEx)} disabled={isReplacing} className={`px-5 py-4 ${theme.secondary} border ${theme.border} rounded-full text-xs font-bold uppercase tracking-widest hover:scale-105 transition-transform flex items-center gap-1.5 w-full justify-center`}>
                    {isReplacing ? 'IA...' : '🔄 Cambiar (Lesión / Material)'}
                  </button>
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <div className={`${theme.card} border ${theme.border} rounded-[2rem] p-10 text-center space-y-4 ${theme.shadow}`}>
          <h3 className="text-xl font-black uppercase tracking-wider">Sin ejercicios para hoy</h3>
          <p className={`text-sm ${theme.muted} font-light leading-relaxed`}>Planifica tu entrenamiento usando el botón de arriba.</p>
        </div>
      )}
    </div>
  );
}
